import React from 'react';
import { getI18NMessage } from './../../../i18n/I18N';
import UI_CONSTANTS from './../../app/constants/UIConstants';
import IconButton from '@mui/material/IconButton';

class LoginFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className='lg-footer'>
                <div className='lg-follow-hdr'>{ getI18NMessage('followus') }</div>
               {
                    this.props.config.map( footerItem => this.getFooterItem(footerItem) )
               }
            </div>
        )
    }

    getFooterItem(config) {
        if ( config.id === UI_CONSTANTS.FOLLOW_US ) {
            const iconMap = {
                facebook: <i className='icon-facebook-with-circle icon'/>,
                blog: <i className='icon-info icon' />,
                twitter: <i className='icon-twitter-with-circle icon' />,
                help:<i className='icon-Help icon'/>,
                support:<i className='icon-Group129 icon'/>
            }

            return (
                <div className='lg-follow-items' key={ config.id }>
                    {
                        config.components.map( comp => (
                            <IconButton size='small' key={ comp.id }
                                onClick={ this.onFollowCompClick.bind(this, comp) }>
                                {
                                    iconMap[comp.id]
                                }
                            </IconButton>
                        ) )
                    }
                </div>
            )
        } else if ( config.id === UI_CONSTANTS.TERMS_AND_CONDITIONS ) {
            return (
                <div className='terms-and-consitions' key={ config.id }>
                    {
                        getI18NMessage('termsandconditions').replace('#companyname#', config.companyname)
                    }
                    &nbsp;<a href={ config.privacy }>{ getI18NMessage('privacy') }</a>
                    &nbsp;&&nbsp;
                    <a href={ config.terms }>{ getI18NMessage('terms') }</a>
                </div>
            )
        } else {
            return false;
        }
    }

    onFollowCompClick(comp) {
        window.open(comp.url)
    }
}

export default LoginFooter;
